import type { SVGProps } from 'react';

import { Circle, Path } from './styles';

export interface SVGButtonProps extends SVGProps<SVGSVGElement> {
  disabled: boolean;
}

export const MinusSVG = ({ disabled, ...otherProps }: SVGButtonProps) => {
  return (
    <svg
      {...otherProps}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="removeOtcSvgTitle"
      aria-describedby="removeOtcSvgDesc"
    >
      <title id="removeOtcSvgTitle">Remove Over the Counter Icon</title>
      <desc id="removeOtcSvgDesc">Decrease the current quantity by 1</desc>
      <Circle disabled={disabled} cx="16" cy="16" r="13" />
      <Path
        disabled={disabled}
        d="M10.5 16C10.5 15.7239 10.7239 15.5 11 15.5H21C21.2761 15.5 21.5 15.7239 21.5 16C21.5 16.2761 21.2761 16.5 21 16.5H11C10.7239 16.5 10.5 16.2761 10.5 16Z"
      />
    </svg>
  );
};

export const PlusSVG = ({ disabled, ...otherProps }: SVGButtonProps) => {
  return (
    <svg
      {...otherProps}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="None"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="addOtcSvgTitle"
      aria-describedby="addOtcSvgDesc"
    >
      <title id="addOtcSvgTitle">Add Over the Counter Icon</title>
      <desc id="addOtcSvgDesc">Increase the current quantity by 1</desc>
      <Circle disabled={disabled} cx="16" cy="16" r="13" />
      <Path
        disabled={disabled}
        d="M10.5 16C10.5 15.7239 10.7239 15.5 11 15.5H21C21.2761 15.5 21.5 15.7239 21.5 16C21.5 16.2761 21.2761 16.5 21 16.5H11C10.7239 16.5 10.5 16.2761 10.5 16Z"
      />
      <Path
        disabled={disabled}
        d="M16 10.5C16.2761 10.5 16.5 10.7239 16.5 11L16.5 21C16.5 21.2761 16.2761 21.5 16 21.5C15.7239 21.5 15.5 21.2761 15.5 21L15.5 11C15.5 10.7239 15.7239 10.5 16 10.5Z"
      />
    </svg>
  );
};
